import React, { useState, useEffect } from 'react';
import { Alert } from "antd";
import SPSteps from 'components/supplier-entry/SPSteps';
import SPSignContract from '../SPSignContract'
import SPDepositPayment from '../SPDepositPayment'
import SPApplySettlementAccount from '../SPApplySettlementAccount'
import {useSupplierEntry} from 'hooks/supplier-entry';
import SPBreadcrumb from 'components/supplier-entry/SPBreadcrumb'
import SPContentWrap from 'components/carRental/base/SPContentWrap';

interface props {
  enums?: any
}

const SPSupplierEntryPage: React.FC<props> = (props) => {
  const { enums } = props
  const [stepCurrent, setStepCurrent] = useState(0)
  const [supplierInfo, setSupplierInfo] = useState<any>()
  const { getSupplierInfo } = useSupplierEntry();

  const getStepCurrent = (supplierInfo:any) => {
    if (supplierInfo?.enter_status === 3) {
      setStepCurrent(3)
    } else {
      if ([0, 1, 2].includes(supplierInfo.entering_status)) {
        setStepCurrent(0)
      } else if (supplierInfo?.entering_status === 4 || supplierInfo?.entering_status === 3) {
        setStepCurrent(1)
      } else if (supplierInfo?.entering_status === 5 && supplierInfo?.pay_deposit_status === 0) {
        setStepCurrent(2)
      } else if (supplierInfo?.entering_status === 5 && supplierInfo?.pay_deposit_status === 1) {
        setStepCurrent(3)
      }
    }
  }

  const nextStep = (step: number) => {
    setStepCurrent(step)
  }

  const preStep = (step: number) => {
    setStepCurrent(step)
  }

  const init = () => {
    return  getSupplierInfo().then((res) => {
      setSupplierInfo(res.data)
      return res
    })
  }

  useEffect(() => {
   init().then((res:any) => {
     getStepCurrent(res.data)
   })
  }, []);

  return (
      <div>
        <SPBreadcrumb supplierInfo={supplierInfo}  title="商家入驻" />
        <SPContentWrap className="common-margin-top">
          { supplierInfo && <>
              <Alert
                  banner
                  message='尊敬的商户，您的账户还没有入驻，请完成以下资料填写，资料审核和通过后即可开通销售权限'
              />
              <SPContentWrap className='common-margin-top'>
                  <SPSteps enums={enums} enumsName="f_supplier_entry_steps_list" current={stepCurrent}></SPSteps>
              </SPContentWrap>
            {stepCurrent === 0 && <SPApplySettlementAccount refresh={init}  nextStep={nextStep} supplierInfo={supplierInfo} enums={enums}></SPApplySettlementAccount>}
            {stepCurrent === 1 && <SPSignContract enums={enums} refresh={init}  nextStep={nextStep} preStep={preStep} supplierInfo={supplierInfo}></SPSignContract>}
            {stepCurrent === 2 && <SPDepositPayment supplierInfo={supplierInfo}></SPDepositPayment>}
            {/*<SPSignContract refresh={init} enums={enums}  nextStep={nextStep} preStep={preStep} supplierInfo={supplierInfo}></SPSignContract>*/}
            {/* <SPDepositPayment supplierInfo={supplierInfo}></SPDepositPayment>*/}
          </>}
        </SPContentWrap>
      </div>
  )
}

export default SPSupplierEntryPage
